module.exports = __webpack_public_path__ + "media/images/badge-green-e71c92864646578ae97c228369e18066.svg";